import { canAccessWhatsNew, MemberFeatureFlags, shouldShowWhatsNewPopup, UserRole } from '@pya-mms/common';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

const useWhatsNewAccess = () => {
  const flags = useSelector((state: RootState) => state.settings.memberFeatureFlags);
  const userRole = useSelector((state: RootState) => state.auth.user?.role);

  const canAccess = (): boolean => {
    if (!userRole) return false;
    return canAccessWhatsNew(userRole, flags);
  };

  const shouldShowPopup = (): boolean => {
    if (!userRole) return false;
    return shouldShowWhatsNewPopup(userRole, flags);
  };

  return {
    flags,
    canAccess,
    shouldShowPopup,
    isPublishedForMembers: flags.whatsNew,
  };
};

export default useWhatsNewAccess;

export const getWhatsNewAccess = (role: UserRole | undefined, flags: MemberFeatureFlags): boolean => {
  if (!role) return false;
  return canAccessWhatsNew(role, flags);
};
